const communityCollab = [
  {
    id: 1,
    img: "https://i.ibb.co/B2y02BK/pug.png",
    name: "",
    website: "http://discord.pugroups.in",
  },
  {
    id: 2,
    img: " https://i.ibb.co/rczqZxS/dsc.jpg",
    name: "",
    website: "https://developerstudentcommunity.co",
  },
  
 
  
];

export default communityCollab;
